import isRequired from './isRequired';

function encodeId(id = isRequired('id', 'encodeId')) {
  return window.btoa(unescape(encodeURIComponent(id)));
}

export default encodeId;
